import React from 'react';
import { useIntl } from 'react-intl';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const modalBodyStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2rem',
};

const successIconStyle: React.CSSProperties = {
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  backgroundColor: '#28a745',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '48px',
  color: 'white',
};

export interface DetergentCompleteModalProps {
  isOpen: boolean;
  detergentPods?: { id: string; title: string }[];
  hide: () => void;
}

const DetergentCompleteModal = React.memo(
  ({ isOpen, detergentPods = [], hide }: DetergentCompleteModalProps) => {
    const intl = useIntl();
    const title = intl.formatMessage({ id: 'detergentsCreated' });
    const message = intl.formatMessage({ id: 'detergentsCreatedMessage' });

    return (
      <Modal
        isOpen={isOpen}
        toggle={hide}
        backdrop="static"
        keyboard={false}
        className="modal-content"
      >
        <ModalHeader>{title}</ModalHeader>
        <ModalBody style={modalBodyStyle}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
            <div style={successIconStyle}>✓</div>
          </div>
          <div style={{ marginTop: '1rem', textAlign: 'center', marginBottom: '1rem' }}>
            {message}
          </div>
          {detergentPods.length > 0 && (
            <div style={{ maxHeight: '300px', overflowY: 'auto', marginTop: '1rem' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
                {intl.formatMessage({ id: 'createdDetergents' })}:
              </div>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {detergentPods.map((pod) => (
                  <li
                    key={pod.id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '0.5rem 0',
                      borderBottom: '1px solid #e0e0e0',
                    }}
                  >
                    <span
                      style={{
                        color: '#28a745',
                        marginRight: '0.5rem',
                        fontSize: '18px',
                        fontWeight: 'bold',
                      }}
                    >
                      ✓
                    </span>
                    <span>{pod.title}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <button className="button" onClick={hide} style={{ marginTop: '1.5rem' }}>
            {intl.formatMessage({ id: 'close' })}
          </button>
        </ModalBody>
      </Modal>
    );
  }
);

DetergentCompleteModal.displayName = 'DetergentCompleteModal';

export default DetergentCompleteModal;
